import { render, staticRenderFns } from "./ChangeDevelopmentBreakdown.vue?vue&type=template&id=448da268&"
import script from "./ChangeDevelopmentBreakdown.vue?vue&type=script&lang=js&"
export * from "./ChangeDevelopmentBreakdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports